module.exports = __webpack_public_path__ + "media/morton.31ee0526.wav";